import { Reveal, Eyebrow } from "./Reveal";
import { MonitorSmartphone, FileSignature, PackageCheck } from "lucide-react";

const ITEMS = [
  {
    n: "01",
    icon: MonitorSmartphone,
    title: "À distance ou en rendez-vous professionnel",
    desc: "Des échanges flexibles, où que vous soyez : visioconférence, téléphone ou rendez-vous en présentiel à Paris 16ᵉ.",
  },
  {
    n: "02",
    icon: FileSignature,
    title: "Au forfait ou sur devis",
    desc: "Une facturation claire et annoncée à l'avance, adaptée à la nature et à l'ampleur de votre besoin.",
  },
  {
    n: "03",
    icon: PackageCheck,
    title: "Des livrables adaptés à votre structure",
    desc: "Contrats, procédures, cartographies des risques, supports de formation : des livrables calibrés pour votre taille et votre secteur.",
  },
];

const AUDIENCES = ["TPE", "PME", "Start-ups", "Associations", "Indépendants"];

export const Prestations = () => (
  <section
    id="prestations"
    data-testid="prestations-section"
    className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-36"
  >
    <div className="grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <Eyebrow>Prestations</Eyebrow>
            <h2 className="mt-5 font-serif text-3xl font-medium leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
              Un accompagnement{" "}
              <em className="italic text-gold">accessible</em> et personnalisé
            </h2>
            <p className="mt-6 text-base leading-relaxed text-mute">
              Chaque mission démarre par l'écoute de votre situation. Les
              modalités sont ensuite construites avec vous, en toute
              transparence.
            </p>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {AUDIENCES.map((a) => (
                <span
                  key={a}
                  data-testid={`audience-chip-${a.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="border border-gold/40 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.18em] text-gold"
                >
                  {a}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7">
        <div className="divide-y divide-ink-line border-y border-ink-line">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <Reveal key={item.n} delay={i * 0.1}>
                <div
                  data-testid={`prestation-item-${i + 1}`}
                  className="group flex gap-6 py-9 transition-colors duration-500 sm:gap-10"
                >
                  <span className="font-serif text-3xl italic text-gold/50 transition-colors duration-500 group-hover:text-gold sm:text-4xl">
                    {item.n}
                  </span>
                  <div>
                    <div className="flex items-center gap-3">
                      <Icon className="h-5 w-5 text-gold" strokeWidth={1.5} />
                      <h3 className="font-serif text-xl font-medium text-ivory sm:text-2xl">
                        {item.title}
                      </h3>
                    </div>
                    <p className="mt-3 max-w-lg text-sm leading-relaxed text-mute sm:text-base">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
